import { supabase } from '@/lib/supabase'

export type PortalFailureReason =
  | 'not_authenticated'
  | 'invoke_failed'
  | 'missing_url'
  | 'unknown'

export type CreatePortalSessionResult =
  | { ok: true; url: string }
  | { ok: false; reason: PortalFailureReason; error?: unknown }

export async function createPortalSession(returnUrl = window.location.href): Promise<CreatePortalSessionResult> {
  try {
    const { data: sessionData } = await supabase.auth.getSession()

    if (!sessionData.session) {
      return { ok: false, reason: 'not_authenticated' }
    }

    const { data, error } = await supabase.functions.invoke('create-portal-session', {
      headers: {
        Authorization: `Bearer ${sessionData.session.access_token}`,
      },
      body: {
        return_url: returnUrl,
      },
    })

    if (error) {
      return { ok: false, reason: 'invoke_failed', error }
    }

    if (!data?.url || typeof data.url !== 'string') {
      return { ok: false, reason: 'missing_url' }
    }

    return { ok: true, url: data.url }
  } catch (error) {
    return { ok: false, reason: 'unknown', error }
  }
}
